import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';

registerLocaleData(localeIT);

@Pipe({
    name: 's1Currency',
    standalone: false
})
export class S1CurrencyPipe implements PipeTransform {

  constructor(private currencyPipe: CurrencyPipe) { }

  transform(value: number): string {

    return this.currencyPipe.transform(value, 'EUR', 'symbol', '1.2-2', 'it')

  }

}
